import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * @desc Get all email templates from api
 */
export function getTemplatesAction(id) {  

    return function (dispatch){
      return APIUtil.getMethod(UrlConstants.emailTemplatesUrl, true).then(response => {

            let data = response.data;
            if(id !== "" && id !== undefined) {
                //if id passed to action then get template data based on id and set it to data
                response.data.map( d => {
                    if(d._id == id) {
                        data = d 
                    }
                })
            }
         
            if(response.status == code.OK) {
                dispatch( {
                    type: types.EMAIL_TEMPLATES,
                    templates: data
                });
            }
            else {
                dispatch( {
                    type: types.EMAIL_TEMPLATES,
                    templates: []
                });
            }
            return response;
      });
    }  
}


/**
 * @desc update email template by id
 */
export function updateTemplatesAction(id, data) {  

    let url = UrlConstants.emailTemplatesUrl + "/" + id

    return function (dispatch){
      return APIUtil.putMethod(url, data, true).then(response => {

         
          if(response.status == code.OK) {
              dispatch( {
                  type: types.UPDATE_EMAIL_TEMPLATE,
                  updatedEmailTemplate: response.data
              });
          }
          else {
              dispatch( {
                  type: types.UPDATE_EMAIL_TEMPLATE,
                  updatedEmailTemplate: []
              });
          }
          return response;
      });
    }  
}

